import React from 'react';
import ClockIcon from '../assets/img/clock-icon.png';
import '../assets/css/progress-bar.css';

const ProgressBar = (props)=> {
    return (
      <>
      <div className="progress-bar-section d-flex justify-content-between align-items-center mb-3">
        <div className="progress-bar mr-2">
          <div className="progress-bar-status" style={{width: props.percent+'%'}}></div>
        </div>
        {props.percent!=''?<span className="fnt-sml">{props.percent+'%'}</span>:<span className="fnt-sml">{props.percent}</span>}
      </div>
      </>
    );
}
export default ProgressBar;